import { useQuery } from "@tanstack/react-query";

import input from "../../../../assets/styles/components/input.module.css";
import { getFinanceAccounts } from "../../../../services/cashFlow";

interface prop {
  handleChangeAccount: (e: string) => void;
  value: string;
  disabled?: boolean;
}

const SelectFinanceAccount = ({ handleChangeAccount, value, disabled }: prop) => {
  const { data } = useQuery({
    queryKey: ["getFinanceAccounts"],
    queryFn: () => getFinanceAccounts(),
  });

  const handleChange = (e: string) => {
    handleChangeAccount(e);
  };
  return (
    <label>
      Conta Financeira
      <select
        className={input.input}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        disabled={disabled}
        data-readonly={disabled}
      >
        <option defaultValue="">{!disabled ? "Selecione" : "-"}</option>
        {data &&
          Object.values(data).length > 0 &&
          data.map((c: { uid_conta_financeira: string; nome: string }) => (
            <option value={c.uid_conta_financeira} key={c.uid_conta_financeira}>
              {c.nome}
            </option>
          ))}
      </select>
    </label>
  );
};

export default SelectFinanceAccount;
